export const endpoints = {
  students: () => `/families/students/`,
  enrollments: () => `/families/enrollments/`,
  enrollment: enrollmentSlug => `/families/enrollments/${enrollmentSlug}/`,
};
